var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'batch': _vm.$route.query.batchPrint},attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]}),_c('el-backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }